module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/userkyc/userkyc.component.css
// module id = ./src/app/Screens/userkyc/userkyc.component.css
// module chunks = main